module.exports = __webpack_public_path__ + "img/407x613 Food.3aa6c80a.jpg";